require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isChecked = exports.handlePress = void 0;

var handlePress = function handlePress(_ref) {
  var onPress = _ref.onPress,
      value = _ref.value,
      onValueChange = _ref.onValueChange;
  onValueChange ? onValueChange(value) : onPress === null || onPress === void 0 ? void 0 : onPress();
};

exports.handlePress = handlePress;

var isChecked = function isChecked(_ref2) {
  var value = _ref2.value,
      status = _ref2.status,
      contextValue = _ref2.contextValue;

  if (contextValue) {
    return contextValue === value ? 'checked' : 'unchecked';
  } else {
    return status;
  }
};

exports.isChecked = isChecked;